import { FC, PropsWithChildren } from 'react';

import { Outlet } from 'react-router-dom';

import { StyledLayout } from './Layout.styled';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Main } from './Main';
import { Acting } from './Acting';
import { MasqueradingFooter } from './MasqueradingFooter';
import { ReEnrolmentActionRequired } from './ReEnrolmentActionRequired';
import { useReEnrolmentRedirect } from './Layout.hooks';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  useReEnrolmentRedirect();

  return (
    <StyledLayout>
      <Header />
      <Sidebar />
      <Main>
        <Outlet />
        {children}
        <MasqueradingFooter />
      </Main>
      <Acting />
      <ReEnrolmentActionRequired />
    </StyledLayout>
  );
};
